import { getMutationTypesForService } from 'shared/utils/createServiceStore.js';
import { USER_SERVICE_KEY } from './userEnum.js';

export default getMutationTypesForService(USER_SERVICE_KEY);
